import { fromJS } from 'immutable';
import {
    GET_EMAILS_REQUEST,
    GET_EMAILS_SUCCESS,
    GET_EMAILS_FAILURE,
    DELETE_EMAILS_REQUEST,
    DELETE_EMAILS_SUCCESS,
    DELETE_EMAILS_FAILURE,
    PUT_EMAILS_REQUEST,
    PUT_EMAILS_SUCCESS,
    PUT_EMAILS_FAILURE,
    POST_EMAILS_REQUEST,
    POST_EMAILS_SUCCESS,
    POST_EMAILS_FAILURE,
} from './actions';

const initialState = fromJS({
    loadingGetEmails: false,
    dataGetEmails: null,
    errorGetEmails: null,
    loadingDeleteEmails: false,
    dataDeleteEmails: null,
    errorDeleteEmails: null,
    loadingPutEmails: false,
    dataPutEmails: null,
    errorPutEmails: null,
    loadingPostEmails: false,
    dataPostEmails: null,
    errorPostEmails: null,
});

const EmailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMAILS_REQUEST:
            return state.set('loadingGetEmails', true);
        case GET_EMAILS_SUCCESS:
            return state.set('loadingGetEmails', false).set('dataGetEmails', action.payload);
        case GET_EMAILS_FAILURE:
            return state.set('loadingGetEmails', false).set('errorGetEmails', action.error);
        case DELETE_EMAILS_REQUEST:
            return state.set('loadingDeleteEmails', true);
        case DELETE_EMAILS_SUCCESS:
            return state.set('loadingDeleteEmails', false).set('dataDeleteEmails', action.payload);
        case DELETE_EMAILS_FAILURE:
            return state.set('loadingDeleteEmails', false).set('errorDeleteEmails', action.error);
        case PUT_EMAILS_REQUEST:
            return state.set('loadingPutEmails', true);
        case PUT_EMAILS_SUCCESS:
            return state.set('loadingPutEmails', false).set('dataPutEmails', action.payload);
        case PUT_EMAILS_FAILURE:
            return state.set('loadingPutEmails', false).set('errorPutEmails', action.error);
        case POST_EMAILS_REQUEST:
            return state.set('loadingPostEmails', true);
        case POST_EMAILS_SUCCESS:
            return state.set('loadingPostEmails', false).set('dataPostEmails', action.payload);
        case POST_EMAILS_FAILURE:
            return state.set('loadingPostEmails', false).set('errorPostEmails', action.error);
        default:
            return state;
    }
};

export default EmailsReducer;
